import React from 'react';

import { Tooltip } from '@mui/material';

import styles from 'components/common/Tables/Cells/DynamicChipsCell/components/DynamicChipsTooltip/DynamicChipsTooltip.module.scss';

import { Chip, ChipSize, ChipType } from 'components/DesignSystem/Chip';

interface Props {
    hiddenItems: string[];
    type?: ChipType;
    size?: ChipSize;
    hiddenCount: number;
}

export const DynamicChipsTooltip = ({ hiddenItems, type, size, hiddenCount }: Props) => {
    return (
        <Tooltip
            title={
                <div className={styles.tooltipCard}>
                    <div className={styles.tooltipList}>
                        {hiddenItems.map((item, index) => (
                            <Chip key={index} label={item} type={type} size={size} />
                        ))}
                    </div>
                </div>
            }
            arrow
            placement={'right'}
            slotProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'var(--bg-quaternary)',
                        color: 'var(--text-primary)',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                        borderRadius: '8px',
                        padding: '16px',
                    },
                },
                arrow: {
                    sx: {
                        color: 'var(--bg-quaternary)',
                    },
                },
            }}
        >
            <div>
                <Chip label={`+ ${hiddenCount}`} type={type} size={size} />
            </div>
        </Tooltip>
    );
};
